// @flow
'use strict';

import * as React from 'react';

import type { IDestinatario } from '../types';
import { tipoDocumento } from './abas_informacoes';

import RowDetalhes from '../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../common/detalhes_documento/column_detalhes';

type DestinatarioProps = {
  destinatario : IDestinatario,
};

export default function Destinatario({ destinatario } : DestinatarioProps) {
  if (!destinatario)
    return <h4 className="text-center" style={ { fontStyle: 'italic' } }>Nenhum destinatário informado no CT-e.</h4>

  return (
      <div className="tab-pane active">
        <h3>Destinatário</h3>
        <RowDetalhes data={ destinatario } className="no-margin-bottom">
          <ColumnDetalhes field="cnpj" type="documento" width="50%">{ tipoDocumento(destinatario) }</ColumnDetalhes>
          <ColumnDetalhes field="ie" width="50%">Inscrição Estadual</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ destinatario } className="no-margin-bottom">
          <ColumnDetalhes field="nomeRazaoSocial" width="50%">Nome / Razão Social</ColumnDetalhes>
          <ColumnDetalhes field="telefone" width="50%">Telefone</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ destinatario } className="no-margin-bottom">
          <ColumnDetalhes field="inscricaoSuframa" width="50%">Inscrição SUFRAMA</ColumnDetalhes>
          <ColumnDetalhes field="endereco" width="50%">Endereço</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ destinatario } className="no-margin-bottom">
          <ColumnDetalhes field="bairro" width="50%">Bairro</ColumnDetalhes>
          <ColumnDetalhes field="municipio" width="50%">Município</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ destinatario } className="no-margin-bottom">
          <ColumnDetalhes field="cep" type="cep" width="50%">CEP</ColumnDetalhes>
          <ColumnDetalhes field="uf" width="50%">UF</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ destinatario }>
          <ColumnDetalhes field="pais" width="50%">País</ColumnDetalhes>
          <ColumnDetalhes field="email" width="50%">E-mail</ColumnDetalhes>
        </RowDetalhes>
      </div>
  );
}
